import uniquifyObject from '@utils/uniquifyObject';
import _cloneDeep from 'lodash/cloneDeep';

// Create a context for all .js files in the current directory
const requireModule = require.context('.', false, /\.js$/);

const modules = {};

// Iterate over each file in the context
requireModule.keys().forEach((fileName) => {
  // Exclude this file and any files you don't want to import
  if (fileName === './all_unique.js' || fileName === './_base.js') return;

  // Import the module
  const module = requireModule(fileName);

  // Destructure the json and info exports
  const { json: templateJson, info: templateInfo } = module;

  // Create the template object
  const template = {
    json: uniquifyObject(_cloneDeep(templateJson)),
    info: templateInfo,
  };

  // Derive the template name from the fileName
  const templateName = fileName.replace('./', '').replace('.js', '');

  // Add the template to the modules object with the template name as the key
  modules[templateName] = template;
});

export default modules;
